'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var R = require('ramda');
var Reselect = require('reselect');

function getTriggerProp(prop) {
  return function (state, props) {
    return R.path([prop], props);
  };
}
/**
 * Gets trigger
 *
 * @typedef GetTriggerSelector
 * @function
 * @param {Array} state
 * @param {Object} props
 * @param {string} props.kind kind
 * @param {string} props.event event
 * @returns {Object} trigger
 */

/**
 * Create `getTrigger` selector instance
 *
 * @returns {GetTriggerSelector}
 */


function createGetTriggerSelector() {
  var getTriggers = createGetTriggersByPrefixSelector();
  return Reselect.createSelector([getTriggers], R.head);
}
/**
 * @deprecated Use `createGetTriggerSelector` instead
 * @see {@link https://github.com/reduxjs/reselect#sharing-selectors-with-props-across-multiple-component-instances}
 */

var getTrigger = createGetTriggerSelector();
/**
 * Gets triggers by prefix
 *
 * @typedef GetTriggerSelectorByPrefix
 * @function
 * @param {Array} state
 * @param {Object} props
 * @param {String} props.kind
 * @param {String} props.event
 * @returns {Array} triggers
 */

/**
 * Create `getTriggerByPrefix` selector instance
 *
 * @returns {GetTriggerSelectorByPrefix}
 */

function createGetTriggersByPrefixSelector() {
  return Reselect.createSelector([R.identity, getTriggerProp('kind'), getTriggerProp('event')], function (triggers, kind, event) {
    return R.filter(function (trigger) {
      var hasMatchingKind = kind == null || R.startsWith(kind, trigger.kind || '');
      var hasMatchingEvent = event == null || R.startsWith(event, trigger.event || '');
      return hasMatchingKind && hasMatchingEvent;
    }, triggers);
  });
}
/**
 * @deprecated Use `createGetTriggersByPrefixSelector` instead
 * @see {@link https://github.com/reduxjs/reselect#sharing-selectors-with-props-across-multiple-component-instances}
 */

var getTriggersByPrefix = createGetTriggersByPrefixSelector();

exports.createGetTriggerSelector = createGetTriggerSelector;
exports.createGetTriggersByPrefixSelector = createGetTriggersByPrefixSelector;
exports.getTrigger = getTrigger;
exports.getTriggersByPrefix = getTriggersByPrefix;
//# sourceMappingURL=selectors.js.map
